import React from "react";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { makeStyles } from "@material-ui/core/styles";
import { Card } from "@material-ui/core";

const useStylesTasks = makeStyles((theme) => ({
    card: {
        marginTop: 10,
        display: "flex",
        flexDirection: "row",
        border: "#F5F5F5 1px solid",
        "&:hover": {
            backgroundColor: () => "#f5f5f5b0",
        },
    },
    ordinal: {
        flexBasis: "5%",
        backgroundColor: "#F5F5F5",
        padding: 12,
    },
    rightPanel: {
        flexBasis: "95%",
        display: "flex",
        flexDirection: "column",
        margin: 0,
        padding: 0,
    },
    name: {
        flexBasis: "95%",
        flexGrow: 0,
        flexShrink: 0,
        padding: 12,
    },
    actions: {
        flexBasis: "5%",
        flexGrow: 0,
        flexShrink: 0,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: 12,
    },
    action: {
        width: 24,
        height: 24,
        padding: 0,
        minWidth: 24,
        minHeight: 24,
    },
    actionIcon: {
        marginLeft: 8,
    },
}));

export default function FlowTask({ task, readOnly, onView, onEdit, onMoveUp, onMoveDown, onMouseOver, isMouseOver }) {
    const classesTask = useStylesTasks();

    const actionButtonCommonProps = {
        variant: "text",
        size: "small",
        className: classesTask.action,
    };

    return (
        <Card className={classesTask.card} onMouseOver={() => onMouseOver(task)} onMouseLeave={() => onMouseOver(undefined)}>
            <div className={classesTask.ordinal}>{task.ordinal}</div>
            <div className={classesTask.rightPanel}>
                <div className={classesTask.name}>{task.name}</div>
            </div>
            <div className={classesTask.actions}>
                {isMouseOver && (
                    <>
                        {!readOnly && (
                            <Button
                                title="Edit task"
                                color="primary"
                                startIcon={<EditIcon className={classesTask.actionIcon} />}
                                onClick={() => onEdit(task)}
                                {...actionButtonCommonProps}
                            >
                                {""}
                            </Button>
                        )}
                        {/* The strong ordered is not implemented yet */}
                        {task && task.strongOrdered && (
                            <>
                                <Button
                                    title="Move up"
                                    color="default"
                                    startIcon={<ArrowUpward className={classesTask.actionIcon} />}
                                    onClick={() => onMoveUp(task)}
                                    {...actionButtonCommonProps}
                                >
                                    {""}
                                </Button>
                                <Button
                                    title="Move down"
                                    color="default"
                                    startIcon={<ArrowDownward className={classesTask.actionIcon} />}
                                    onClick={() => onMoveDown(task)}
                                    {...actionButtonCommonProps}
                                >
                                    {""}
                                </Button>
                            </>
                        )}
                    </>
                )}
                <Button
                    title="View task"
                    color="primary"
                    startIcon={<VisibilityIcon className={classesTask.actionIcon} />}
                    onClick={() => onView(task)}
                    {...actionButtonCommonProps}
                >
                    {""}
                </Button>
            </div>
        </Card>
    );
}
